export function searchFormHandler() {
    try {
        defaultQuery;
    } catch (e) {
        if (e.name === "ReferenceError") {
            window.defaultQuery = "";
        }
    }
    console.log(defaultQuery);
    let currentPage = 1,
        form = $(".formSearchAjax"),
        postsPerPage = parseInt(form.data('posts-per-page')),
        postType = form.data('post-type'),
        currentQuery = 'post_type=' + postType,
        isSlider = form.data('is-slider'),
        isAjaxWorking = false;
    postsPerPage = postsPerPage ? postsPerPage : 8;
    currentQuery += "&posts_per_page=" + postsPerPage + defaultQuery;

    form.on('submit', function () {
        if (isAjaxWorking)
            return false;
        let data = $(this).serialize().replace('&category=all', ''),
            categorySelect = $(this).find("select[name=category]"),
            taxonomy = categorySelect.data('tax-name');
        if (categorySelect.val() && categorySelect.val() !== "all")
            data += "&post_type_category=" + taxonomy;
        data += "&post_type=" + $(this).data('post-type');
        data += "&posts_per_page=" + postsPerPage;
        currentQuery = data + defaultQuery;
        currentPage = 1;
        $(this).find("select").attr("disabled", "disabled");
        getResults(currentQuery, $(this).parent().find(".results"), $(this).parent().find(".pagination"));
        return false;
    });

    form.find('select').on("change", function () {
        $(this).parents("form").submit();
    });

    let getResults = function (query, postsContainer, paginationContainer) {
        if (isAjaxWorking)
            return;
        isAjaxWorking = true;
        let serachOverlay = $("<div id='search-overlay' style='display:none;z-index:2000000000;background:rgba(255,255,255,0.7);position: fixed;left:0;right:0;top:0;bottom:0;'>");
        postsContainer.parent().append(serachOverlay);
        setTimeout(function () {
            $("#search-overlay").fadeIn();
        }, 20)
        $.getJSON("/wp-json/shamrock/v1/events/search?" + query + "&paged=" + currentPage, function (results) {
            let num = typeof results.max_num_pages === "undefined" ? 0 : results.max_num_pages,
                posts = results.posts,
                postsContainerHTML = "";
            window.resultsCount = posts.length;
            if (postType === "recipe") {
                for (let i = 0; i < posts.length; i++) {
                    postsContainerHTML += renderRecipesPost(posts[i].thumbnail, posts[i].title, posts[i].content, posts[i].link, posts[i].category, posts[i].servings, i + 1, isSlider);
                }
            } else {
                for (let i = 0; i < posts.length; i++) {
                    postsContainerHTML += renderPost(posts[i].thumbnail, posts[i].title, posts[i].content, posts[i].date, posts[i].link);
                }
            }
            if (posts.length) {

                if (isSlider) {
                    let parent = postsContainer.parent();
                    postsContainer.remove();
                    parent.append($("<div class='recipes-slider results'>"));
                    postsContainer = parent.find(".results");
                }
                postsContainer.html(postsContainerHTML);
                if (isSlider) {
                    postsContainer.parent().trigger('new-init');
                }
            } else
                postsContainer.html("<div class='container'>No results</div>");
            let pagination = generatePagination(num, currentPage);
            paginationContainer.find(".pagination-list").html(pagination);
            prepatePagination();
            linkH3();

        }).always(function () {
            form.find("select").removeAttr("disabled");
            isAjaxWorking = false;
            $("#search-overlay").fadeOut(400, function () {
                $(this).remove();
            })
        });
    };

    let changePage = function (page) {
        if (isAjaxWorking)
            return;
        if (currentPage === page)
            return;
        currentPage = page;
        getResults(currentQuery, form.parent().find(".results"), form.parent().find(".pagination"));
    };
    let generatePagination = function (maxNumPages, currentPage) {
        let pag = [],
            nextButton = form.parent().find(".pagination .next"),
            prevButton = form.parent().find(".pagination .prev");
        if (maxNumPages < 2) {
            prevButton.addClass("hidden");
            nextButton.addClass("hidden");
            return "";
        }
        prevButton.data("page", currentPage - 1);
        nextButton.data('page', currentPage + 1);
        if (maxNumPages <= currentPage) {
            nextButton.addClass("hidden");
        } else {
            nextButton.removeClass("hidden");
        }

        if (1 >= currentPage) {
            prevButton.addClass("hidden");
        } else {
            prevButton.removeClass("hidden");
        }
        for (let i = 0; i < maxNumPages; i++) {
            pag.push("<li data-page='" + (i + 1) + "'>" + (i + 1) + "</li>");
        }
        if (maxNumPages <= 4)
            return pag.join("");
        if (currentPage <= 3) {
            pag.splice(3, maxNumPages - 4, "<li>...</li>")
            return pag.join("");
        }
        if (maxNumPages - currentPage < 3) {
            pag[1] = "<li>...</li>";
            pag.splice(2, maxNumPages - 5);
            return pag.join("");
        }
        pag = ["<li data-page='1'>1</li>", "<li>...</li>"];
        for (let i = 0; i < 3; i++) {
            let index = currentPage - 1 + i;
            pag.push("<li data-page='" + index + "'>" + index + "</li>");
        }
        pag.push("<li>...</li>");
        pag.push("<li data-page='" + maxNumPages + "'>" + maxNumPages + "</li>");
        return pag.join("");
    };
    let linkH3 = function () {
        $(".item__desc-sm, .item__desc-big").find("h3").on('click', function () {
            window.location.href = $(this).siblings("a").get(0).href;

        }).css('cursor', 'pointer');
    };
    let prepatePagination = function () {
        setTimeout(function () {
            $("[data-page=" + currentPage + "]").addClass("active");
            $("[data-page]").unbind("click").on('click', function () {
                changePage(parseInt($(this).data('page')));
            });
        }, 50);
    };
    let renderPost = function (thumbnail, title, content, date, link) {
        return "<div class=\"col-12 col-sm-6 col-lg-3 item\">\n" +
            "                        <div class=\"post__box\">\n" +
            "                            <div class=\"post__image\"\n" +
            "                                 style=\"background: url('" + thumbnail + "') no-repeat center; background-size: cover;\"></div>\n" +
            "                            <div class=\"post__content\">\n" +
            "                                <h6 class=\"color__cedar\">\n" +
            "                                    " + title + "\n" +
            "                                </h6>\n" +
            "                                <p>\n" +
            "                                    " + content + "\n" +
            "                                </p>\n" +
            "                                <span class=\"date color__tree-poppy\">" + date + "</span>\n" +
            "                                <a href=\"" + link + "\" class=\"btn btn__porcelain\">\n" +
            "                                    Read more\n" +
            "                                </a>\n" +
            "                            </div>\n" +
            "                        </div>\n" +
            "                    </div>";
    };

    let renderRecipesPost = function (thumbnail, title, content, link, category, servings, index, slider = false) {
        return (slider ? "" : "<div class=\"" + ((index === 2) ? 'col-12 col-md-6 col-lg-8' : 'col-12 col-md-6 col-lg-4') + "\">\n") +
            "                    <div class=\"item item__desc-" + ((index === 2) ? 'big' : 'sm') + "\">\n" +
            "\n" +
            "                        <div class=\"background\" style=\"background: url(" + thumbnail + ") no-repeat center; background-size: cover;\">\n" +
            "                            <a href="+ link +" class=\"link-absolute\"></a>\n" +
            "                            <a href=\"" + link + "\" class=\"like\">\n" +
            "                                <svg width=\"24px\" height=\"22px\" viewBox=\"0 0 24 22\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n" +
            "                                    <g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n" +
            "                                        <g id=\"Favourite---Wireframe\" transform=\"translate(-25.000000, -23.000000)\" fill=\"#B9B9B9\">\n" +
            "                                            <path d=\"M25,29.5809506 C25,33.9189506 31.781,37.6549506 36.781,44.4909506 C41.781,37.6549506 48.562,33.9189506 48.562,29.5809506 C48.562,23.9559506 41.011,19.9579506 36.781,26.0569506 C32.799,19.9579506 25,23.9559506 25,29.5809506 Z\" id=\"Fill-1\"></path>\n" +
            "                                        </g>\n" +
            "                                    </g>\n" +
            "                                </svg>\n" +
            "                            </a>\n" +
            "                            <div class=\"content\">\n" +
            "                                <div class=\"category\">\n" +
            "                                <span class=\"btn btn__tab btn__tab--white\">\n" +
            "                                    " + category + "\n" +
            "                                </span>\n" +
            "                                    <span class=\"btn btn__tab btn__tab--white btn__tab__person\">\n" +
            "                                    " + servings + "\n" +
            "                                </span>\n" +
            "                                </div>\n" +
            "                                <div class=\"content__text\">\n" +
            "                                    <h3>\n" +
            "                                        " + title + "\n" +
            "                                    </h3>\n" +
            "                                    <p>\n" +
            "                                        " + content + "\n" +
            "                                    </p>\n" +
            "                                    <a href=\"" + link + "\" class=\"btn btn__porcelain\">\n" +
            "                                        Get the recipe\n" +
            "                                    </a>\n" +
            "                                </div>\n" +
            "                            </div>\n" +
            "                        </div>\n" +
            "                    </div>\n" +
            (slider ? "" : "                </div>");
    };
    let currentPages = $("[data-max-page]").data('max-page');
    form.parent().find(".pagination .pagination-list").html(generatePagination(currentPages, currentPage));
    prepatePagination();
    linkH3();

}